import { Input } from "@/components/ui/input";

interface LeadFormFieldsProps {
  newLead: {
    email: string;
    full_name: string;
    company: string;
    role_title: string;
  };
  setNewLead: (lead: any) => void;
}

export const LeadFormFields = ({ newLead, setNewLead }: LeadFormFieldsProps) => {
  return (
    <>
      <Input
        placeholder="Email"
        value={newLead.email}
        onChange={(e) => setNewLead(prev => ({ ...prev, email: e.target.value }))}
        className="flex-1"
      />
      <Input
        placeholder="Full Name"
        value={newLead.full_name}
        onChange={(e) => setNewLead(prev => ({ ...prev, full_name: e.target.value }))}
        className="flex-1"
      />
      <Input
        placeholder="Company"
        value={newLead.company}
        onChange={(e) => setNewLead(prev => ({ ...prev, company: e.target.value }))}
        className="flex-1"
      />
      <Input
        placeholder="Role"
        value={newLead.role_title}
        onChange={(e) => setNewLead(prev => ({ ...prev, role_title: e.target.value }))}
        className="flex-1"
      />
    </>
  );
};